import { useCallback } from 'react';
import { useWLOrgConfigContext } from '../providers/WLOrgConfigProvider';
import type { CustomerOrder } from '../types/CustomerOrder';
import { WLCanCancelCustomerOrder, WLCanModifyCustomerOrder } from '../utils/order';

type WLModifiableCustomerOrder = Pick<CustomerOrder, 'Strategy' | 'OrdStatus' | 'RFQID' | 'CustomerUser'>;
type WLCancelableCustomerOrder = Pick<CustomerOrder, 'CustomerUser'>;

export const useWLCanModifyCustomerOrder = () => {
  const { config } = useWLOrgConfigContext();

  return useCallback((order: WLModifiableCustomerOrder) => WLCanModifyCustomerOrder(order, config), [config]);
};

export const useWLCanCancelCustomerOrder = () => {
  const { config } = useWLOrgConfigContext();

  return useCallback((order: WLCancelableCustomerOrder) => WLCanCancelCustomerOrder(order, config), [config]);
};
